import React from 'react';
import Icon from '../../../components/AppIcon';

const TabNavigation = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'trips', label: 'My Trips', icon: 'Map', count: 5 },
    { id: 'favorites', label: 'Favorites', icon: 'Heart', count: 12 },
    { id: 'bookings', label: 'Bookings', icon: 'Calendar', count: 3 },
    { id: 'recommendations', label: 'For You', icon: 'Sparkles', count: null },
    { id: 'settings', label: 'Settings', icon: 'Settings', count: null }
  ];

  return (
    <>
      {/* Desktop Tab Navigation */}
      <div className="hidden md:block bg-card border-b border-border sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <nav className="flex gap-1">
            {tabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => onTabChange(tab?.id)}
                className={`flex items-center gap-2 px-4 lg:px-6 py-4 font-medium transition-all duration-250 border-b-2 ${
                  activeTab === tab?.id
                    ? 'border-primary text-primary bg-primary/5' :'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
              >
                <Icon name={tab?.icon} size={18} />
                <span className="text-sm lg:text-base">{tab?.label}</span>
                {tab?.count !== null && (
                  <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                    activeTab === tab?.id
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-muted-foreground'
                  }`}>
                    {tab?.count}
                  </span>
                )}
              </button>
            ))}
          </nav>
        </div>
      </div>
      {/* Mobile Bottom Navigation */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50 safe-area-bottom">
        <nav className="flex justify-around items-center px-2 py-2">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => onTabChange(tab?.id)}
              className={`flex flex-col items-center gap-1 px-3 py-2 rounded-lg transition-all duration-250 min-w-[60px] ${
                activeTab === tab?.id
                  ? 'text-primary bg-primary/10' :'text-muted-foreground'
              }`}
            >
              <div className="relative">
                <Icon name={tab?.icon} size={20} />
                {tab?.count !== null && (
                  <span className="absolute -top-1 -right-1 w-4 h-4 bg-primary text-primary-foreground text-[10px] font-bold rounded-full flex items-center justify-center">
                    {tab?.count}
                  </span>
                )}
              </div>
              <span className="text-[10px] font-medium">{tab?.label}</span>
            </button>
          ))}
        </nav>
      </div>
    </>
  );
};

export default TabNavigation;